import React from 'react';
import Contact from '../components/sections/Contact';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      <Contact />
    </div>
  );
};

export default ContactPage;
